import { render, staticRenderFns } from "./AboutusPage.vue?vue&type=template&id=b1b36ab2&scoped=true"
import script from "./AboutusPage.vue?vue&type=script&lang=js"
export * from "./AboutusPage.vue?vue&type=script&lang=js"
import style0 from "./AboutusPage.vue?vue&type=style&index=0&id=b1b36ab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b36ab2",
  null
  
)

export default component.exports